import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import SectionNavLink from '@zg-rentals/multibrand-ui/lib/SectionNavLinkCometTemp';

export default function SummaryNavLink({ title, description, button, alert }) {
  return (
    <>
      {alert}
      <SectionNavLink
        customClass={cx('ApplicantSection__Row')}
        customTitleClass={cx('Text-h3', 'ApplicantSection__Row__Title')}
        title={title}
        description={description}
        customRightSection={button}
        customRightSectionClass="SectionNav_Button"
      />
    </>
  );
}

SummaryNavLink.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  button: PropTypes.node,
  alert: PropTypes.node,
};

SummaryNavLink.displayName = 'SummaryNavLink';
